// remove all whitespace
export function removeWhitespace(str: string) {
  return str.replace(/\s/g, "")
}

// is Number
export function isNumber(str: any) {
  return !isNaN(parseFloat(str)) && isFinite(str)
}

// is Letter
export function isLetter(str: string) {
  return str.length === 1 && str.match(/[a-z]/i)
}

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message
  } else if (typeof error === "string") {
    return error
  } else {
    return JSON.stringify(error)
  }
}

export function uppercase<T extends string>(str: T): `${Uppercase<T>}` {
  return str.toUpperCase() as `${Uppercase<T>}`
}
